(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["g_password-footer"]) return;
  try {
    
    const pwdFooter = document.querySelector('[data-password-footer]');
    document.documentElement.style.setProperty('--password-footer-height', `${pwdFooter.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g_password-header"]) return;
  try {
    
    const pwdHeader = document.querySelector('[data-password-header]');
    document.documentElement.style.setProperty('--password-header-height', `${pwdHeader.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solar-roi-calculator-v2"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', function() {
    if(document.querySelector('.results-custom') && document.querySelector('#MainContent')) {
       document.querySelector('#MainContent').appendChild(document.querySelector('.results-custom'));
       document.querySelector('.results-custom').style.display = 'block';
     }
    document.querySelector('.calculate-link').addEventListener('click', calculateResults);
    document.querySelector('.calculate-link').addEventListener('touch', calculateResults);
    document.querySelector('.calculate-link-form').addEventListener('click', calculateResults);
    document.querySelector('.calculate-link-form').addEventListener('touch', calculateResults);
    function calculateResults(e) {
      e.preventDefault();
      let a = [];
      document.querySelectorAll('input[type=number]').forEach(function(element) {
        a.push(parseFloat(element.value != ''? element.value : 100));
      });
      let i1 = 0.9;
      let i2 = 21;
      
      let dayKWH = a[0]*a[1]*12/1000;
      let monthKWH = dayKWH*30;
      let yearKWH = dayKWH*365;
      
      let dayCost = dayKWH*a[2];
      let monthCost = dayCost*30;
      let yearCost = monthCost*12;
      let savings = yearCost*10;

      let r1 = yearKWH*i1;
      let r2 = r1/i2;
      document.querySelector('.monthly').innerHTML = monthCost.toFixed(2);
      document.querySelector('.output_number').innerHTML = monthCost.toFixed(2);
      document.querySelector('.yearly').innerHTML = yearCost.toFixed(2);
      document.querySelector('.lifetime').innerHTML = savings.toFixed(2);
      document.querySelector('.daily_value').innerHTML = parseFloat(dayKWH.toFixed());
      document.querySelector('.monthly_value').innerHTML = parseFloat(monthKWH.toFixed(2));
      document.querySelector('.yearly_value').innerHTML = parseFloat(yearKWH.toFixed(2));
      document.querySelector('.output_value1').innerHTML = parseFloat(r1.toFixed(2));
      document.querySelector('.output_value2').innerHTML = parseInt(r2.toFixed(2));
      let p = document.querySelectorAll('.\\#product-card-custom-data');
      if(p) {
        p.forEach(function(element) {
          let price = parseFloat(element.getAttribute('data-price'));
          let r3 = a[1]*price;
          let r4 = r3/yearCost;
          element.querySelector('.total-investment-value').innerHTML = r3.toFixed(2);
          element.querySelector('.roi-years-value').innerHTML = parseFloat(r4.toFixed(2));
        });
      }
    }
    document.querySelector('.calculate-link').click();
    document.querySelector('.download_link').addEventListener('click', downloadImage);
    document.querySelector('.download_link').addEventListener('touch', downloadImage);
    function downloadImage() {
      html2canvas(document.querySelector(".results-section"), { useCORS: true, backgroundColor: null }).then(canvas => {
        let link = document.createElement('a');
        link.download = 'download_image.png';
        link.href = canvas.toDataURL();
        link.click();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solar-roi-calculator"] && !Shopify.designMode) return;
  try {
    
  /* window.onload = function() { */
  window.addEventListener('load', function() {
    if(document.querySelector('.results-custom') && document.querySelector('#MainContent')) {
       document.querySelector('#MainContent').appendChild(document.querySelector('.results-custom'));
       document.querySelector('.results-custom').style.display = 'block';
     }
    document.querySelector('.calculate-button').addEventListener('click', calculateResults);
    document.querySelector('.calculate-button').addEventListener('touch', calculateResults);
    function calculateResults(e) {
      e.preventDefault();
      let a = [];
      document.querySelectorAll('input[type=number]').forEach(function(element) {
        a.push(parseFloat(element.value != ''? element.value : 100));
      });
      let i1 = 0.9;
      let i2 = 21;
      
      let dayKWH = a[0]*a[1]*12/1000;
      let monthKWH = dayKWH*30;
      let yearKWH = dayKWH*365;
      
      let dayCost = dayKWH*a[2];
      let monthCost = dayCost*30;
      let yearCost = monthCost*12;
      let savings = yearCost*10;

      let r1 = yearKWH*i1;
      let r2 = r1/i2;
      document.querySelector('.output-data1').innerHTML = '<div class="heading">Estimated Savings</div>'
        +'<div><div>Monthly Electicity Bill</div><div>&#8377;'+monthCost.toFixed(2)+'</div></div><div class="gradient"></div>'
        +'<div><div>Yearly Electricity Bill</div><div>&#8377;'+yearCost.toFixed(2)+'</div></div><div class="gradient"></div>'
        +'<div><div>Lifetime Electricity Bill</div><div>&#8377;'+savings.toFixed(2)+'</div></div>';
      document.querySelector('.output-data2').innerHTML = '<div class="heading">Estimated Consumption</div>'
        +'<div><div>Daily Electricity Consumption in KWH</div><div>'+parseFloat(dayKWH.toFixed())+'</div></div><div class="gradient"></div>'
        +'<div><div>Monthly Electricity Consumption in KWH</div><div>'+parseFloat(monthKWH.toFixed(2))+'</div></div><div class="gradient"></div>'
        +'<div><div>Yearly Electricity Consumption in KWH</div><div>'+parseFloat(yearKWH.toFixed(2))+'</div></div>';
      document.querySelector('.output_value1').innerHTML = parseFloat(r1.toFixed(2));
      document.querySelector('.output_value2').innerHTML = parseInt(r2.toFixed(2));
      document.querySelector('.output').style.display = 'flex';
      let svgImage = '<span class="svg-image-roi"><svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">'
        +'<path d="M9.00001 0.5L9.01801 0.501L9.03401 0.502L9.11701 0.507L9.12801 0.509H9.13901L9.17701 0.518L9.22901 0.526L9.24501 0.532L9.25601 0.533L9.28501 0.544L9.33701 0.558L9.35601 0.567L9.37101 0.571L9.39901 0.585L9.43901 0.602L9.46001 0.614L9.48201 0.624L9.50501 0.639L9.53601 0.656L9.57001 0.68L9.58801 0.691L9.60101 0.703L9.62501 0.72L9.66301 0.754L9.68501 0.771L9.69301 0.781L9.70701 0.793L9.74301 0.834L9.76901 0.861L9.77501 0.87C9.89501 1.017 9.97101 1.192 9.99301 1.383L9.99401 1.395L9.99601 1.436L10 1.5V7.5H15C15.1753 7.49996 15.3475 7.54598 15.4993 7.63345C15.6512 7.72092 15.7774 7.84677 15.8654 7.99839C15.9533 8.15001 15.9998 8.32208 16.0003 8.49734C16.0007 8.67261 15.9551 8.84491 15.868 8.997L15.808 9.088L7.808 20.088C7.24001 20.871 6.00001 20.468 6.00001 19.5V13.5H1.00001C0.824741 13.5 0.652543 13.454 0.500667 13.3666C0.348792 13.2791 0.222573 13.1532 0.134659 13.0016C0.0467459 12.85 0.000225215 12.6779 -0.000240608 12.5027C-0.00070643 12.3274 0.044899 12.1551 0.132005 12.003L0.192005 11.912L8.19201 0.912L8.20201 0.899L8.22001 0.875L8.25301 0.837L8.27101 0.815L8.28001 0.807L8.29301 0.793L8.33301 0.757L8.36101 0.731L8.36901 0.725C8.48621 0.629081 8.62366 0.561036 8.77101 0.526L8.78201 0.525L8.80901 0.52L8.88301 0.507L8.89401 0.506L8.93501 0.504L9.00001 0.5Z" fill="#FBCF00"/>'
        +'</svg></span>';
      let p = document.querySelectorAll('.\\#product-card-custom-data');
      if(p) {
        p.forEach(function(element) {
          let price = parseFloat(element.getAttribute('data-price'));
          let r3 = a[1]*price;
          let r4 = r3/yearCost;
          element.querySelector('.total-investment').innerHTML = 'Total Investment &#8377;'+r3.toFixed(2);
          element.querySelector('.roi-years').innerHTML = svgImage+'ROI '+parseFloat(r4.toFixed(2))+' Years';
        });
      }
      /* const section = document.getElementById("results");
      section.scrollIntoView({ behavior: "smooth" }); */
    }
    document.querySelector('.calculate-button').click();
    document.querySelector('.download_link').addEventListener('click', downloadImage);
    document.querySelector('.download_link').addEventListener('touch', downloadImage);
    function downloadImage() {
      html2canvas(document.querySelector(".results-section-custom"), { useCORS: true, backgroundColor: null }).then(canvas => {
        let link = document.createElement('a');
        link.download = 'download_image.png';
        link.href = canvas.toDataURL();
        link.click();
      });
    }
  });
  /* }; */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solar-roi-calculator__dated03102024"] && !Shopify.designMode) return;
  try {
    
  window.onload = function() {
    document.querySelector('.calculatorModule-calculateButton').addEventListener('click', calculateResults);
    document.querySelector('.calculatorModule-calculateButton').addEventListener('touch', calculateResults);
    function calculateResults(e) {
      e.preventDefault();
      let a = [];
      document.querySelectorAll('.calculatorModule-input input').forEach(function(element) {
        a.push(parseFloat(element.value));
      });
      let i1 = 0.9;
      let i2 = 22;
      
      let dayKWH = a[0]*a[1]*12/1000;
      let monthKWH = dayKWH*30;
      let yearKWH = dayKWH*365;
      
      let dayCost = dayKWH*a[2];
      let monthCost = dayCost*30;
      let yearCost = monthCost*12;
      let savings = yearCost*10;

      let r1 = yearKWH*i1;
      let r2 = r1*i2;

      /* document.querySelector('table.input-data').innerHTML = '<tr><th>LED Wattage</th><th>Number of units</th><th>Elec charge/KWH</th>'
        +'</tr><tr><td>'+a[0]+'</td><td>'+a[1]+'</td><td>'+a[2]+'</td></tr>'; */
      document.querySelector('table.output-data1').innerHTML = '<tr><td>Daily Electricity Consumption in KWH</td><td>'+parseFloat(dayKWH.toFixed())+'</td></tr>'
      +'<tr><td>Monthly Electricity Consumption in KWH</td><td>'+parseFloat(monthKWH.toFixed(2))+'</td></tr>'
      +'<tr><td>Yearly Electricity Consumption in KWH</td><td>'+parseFloat(yearKWH.toFixed(2))+'</td></tr>';
      document.querySelector('table.output-data2').innerHTML = '<tr><td>Monthly Electicity Bill</td><td>&#8377;'+monthCost.toFixed(2)+'</td></tr>'
      +'<tr><td>Yearly EB</td><td>&#8377;'+yearCost.toFixed(2)+'</td></tr>'
      +'<tr><td>Lifetime savings</td><td>&#8377;'+savings.toFixed(2)+'</td></tr>';
      document.querySelector('table.output-data3').innerHTML = '<tr><td>CO2 Emission Reduced/year (kg)</td><td>'+parseFloat(r1.toFixed(2))+'</td></tr>'
      +'<tr><td>Number of trees saved/Planted</td><td>'+parseFloat(r2.toFixed(2))+'</td></tr>';
      document.querySelector('.calculatorModule-result-wrap').style.display = 'block';
      let p = document.querySelectorAll('.\\#product-card-custom-data');
      if(p) {
        p.forEach(function(element) {
          let price = parseFloat(element.getAttribute('data-price'));
          let r3 = a[1]*price;
          let r4 = r3/yearCost;
          element.querySelector('.total-investment').innerHTML = 'Total Investment<br />&#8377;'+r3.toFixed(2);
          element.querySelector('.roi-years').innerHTML = 'ROI(Years)<br />'+parseFloat(r4.toFixed(2));
        });
      }
    }
  };

  } catch(e) { console.error(e); }
})();
})();
